import React from 'react';
import FreteNote from '../FreteNote';
import {
  FooterContainer,
  FooterContent,
  FooterTop,
  FooterBrand,
  FooterColumn,
  FooterLink,
  FooterBottom,
  FooterText,
} from './styles';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer role="contentinfo">
      <FooterContent>
        <FooterTop>
          <FooterBrand>
            <h3>Viviane <span>Balas</span></h3>
            <p>
              Doces artesanais preparados com carinho e ingredientes selecionados.
              Cada receita carrega tradição e um sabor que marca.
            </p>
            <FreteNote variant="footer" />
          </FooterBrand>
          <FooterColumn>
            <h4>Navegação</h4>
            <FooterLink href="/#hero">Início</FooterLink>
            <FooterLink href="/#catalogo">Produtos</FooterLink>
            <FooterLink href="/#sobre">Sobre Nós</FooterLink>
            <FooterLink href="/#localizacao">Localização</FooterLink>
            <FooterLink href="/#contato">Contato</FooterLink>
          </FooterColumn>
          <FooterColumn>
            <h4>Fale Conosco</h4>
            <FooterLink
              href="https://wa.me/5532988583597"
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp
            </FooterLink>
            <FooterLink
              href="https://www.instagram.com/vivibalasartesanais"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </FooterLink>
          </FooterColumn>
        </FooterTop>
        <FooterBottom>
          <FooterText>
            &copy; {currentYear} Viviane Balas e Biscoitos Artesanais. Todos os direitos reservados.
          </FooterText>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;

